export const STATUS_TYPES = {
  APPOINTMENT_STATUS_CHECKED_IN: "APPOINTMENT_STATUS_CHECKED_IN",
  APPOINTMENT_STATUS_MISSED: "APPOINTMENT_STATUS_MISSED",
  APPOINTMENT_STATUS_CENTER_MISSED: "APPOINTMENT_STATUS_CENTER_MISSED",
  APPOINTMENT_STATUS_CANCELLED: "APPOINTMENT_STATUS_CANCELLED", //cancelled client
  APPOINTMENT_STATUS_CANCELLED_CENTRE: "APPOINTMENT_STATUS_CANCELLED_CENTRE",
  APPOINTMENT_STATUS_CANCELLED_NO_PAYMENT: "APPOINTMENT_STATUS_CANCELLED_NO_PAYMENT",
  APPOINTMENT_STATUS_CANCELLED_LATE: "APPOINTMENT_STATUS_CANCELLED_LATE",
  APPOINTMENT_STATUS_UNCONFIRMED: "APPOINTMENT_STATUS_UNCONFIRMED",
  APPOINTMENT_STATUS_RESCHEDULED: "APPOINTMENT_STATUS_RESCHEDULED",
  APPOINTMENT_STATUS_CONFIRMED: "APPOINTMENT_STATUS_CONFIRMED",
  APPOINTMENT_STATUS_CONFIRMED_W: "APPOINTMENT_STATUS_CONFIRMED_W",
  APPOINTMENT_STATUS_CONFIRMED2: "APPOINTMENT_STATUS_CONFIRMED2",
  APPOINTMENT_STATUS_IN_WAITING: "APPOINTMENT_STATUS_IN_WAITING",
  APPOINTMENT_STATUS_COMPLETE: "APPOINTMENT_STATUS_COMPLETE",
  APPOINTMENT_STATUS_WILL_CALL: "APPOINTMENT_STATUS_WILL_CALL",
  APPOINTMENT_STATUS_BEING_SEEN: "APPOINTMENT_STATUS_BEING_SEEN",
  APPOINTMENT_STATUS_NO_ANSWER: "APPOINTMENT_STATUS_NO_ANSWER",
  APPOINTMENT_STATUS_SWITCHED_OFF: "APPOINTMENT_STATUS_SWITCHED_OFF",
  APPOINTMENT_STATUS_WALK_IN: "APPOINTMENT_STATUS_WALK_IN",
  APPOINTMENT_STATUS_ASSESSMENT: "APPOINTMENT_STATUS_ASSESSMENT",
  APPOINTMENT_STATUS_CANCELLED_RESCHEDULED: "APPOINTMENT_STATUS_CANCELLED_RESCHEDULED",
  APPOINTMENT_STATUS_PARTIALLY_PAYED: "APPOINTMENT_STATUS_PARTIALLY_PAYED",
  APPOINTMENT_STATUS_MISSED_RESCHEDULED: "APPOINTMENT_STATUS_MISSED_RESCHEDULED",
  APPOINTMENT_STATUS_VOIDED: "APPOINTMENT_STATUS_VOIDED",
  APPOINTMENT_STATUS_CLINICIAN_CANCELLED: "APPOINTMENT_STATUS_CLINICIAN_CANCELLED",
  APPOINTMENT_STATUS_CENTER_LATE_CANCELLED: "APPOINTMENT_STATUS_CENTER_LATE_CANCELLED",
  APPOINTMENT_STATUS_CLINICIAN_LATE_CANCELLED: "APPOINTMENT_STATUS_CLINICIAN_LATE_CANCELLED",
  APPOINTMENT_STATUS_CLINICIAN_NO_SHOW: "APPOINTMENT_STATUS_CLINICIAN_NO_SHOW",
  APPOINTMENT_STATUS_CANCELLED_CONSUMED: "APPOINTMENT_STATUS_CANCELLED_CONSUMED",
  APPOINTMENT_STATUS_CLIENT_LATE_CANCELLATION_WAIVED:
    "APPOINTMENT_STATUS_CLIENT_LATE_CANCELLATION_WAIVED",
  APPOINTMENT_STATUS_CLIENT_LATE_CANCELLATION_50: "APPOINTMENT_STATUS_CLIENT_LATE_CANCELLATION_50",
  APPOINTMENT_STATUS_CLIENT_LATE_CANCELLATION_FULLY_CHARGED:
    "APPOINTMENT_STATUS_CLIENT_LATE_CANCELLATION_FULLY_CHARGED",
  APPOINTMENT_STATUS_CLIENT_MISSED_WAIVED: "APPOINTMENT_STATUS_CLIENT_MISSED_WAIVED",
  APPOINTMENT_STATUS_CLIENT_MISSED_FULLY_CHARGED: "APPOINTMENT_STATUS_CLIENT_MISSED_FULLY_CHARGED",
};
